import axios from '@/libs/axios'

export default {
  state: {
    services: [],
    widget_settings: {},
    language: '',
    error_settings: {
      "title": "There is an error on the booking page!",
      "left_tab": "Services",
      "right_tab": "Specialists",
      "locale": "en",
      "main_color": "#EA5455",
      "button_color": "#EA5455",
      "position": "right",
      "lat": 2,
      "lng": 4,
      "icon": "one_line",
      "animation": "none",
      "second_line": "",
      "first_line": "Error!",
      "size": "sidebar-lg",
      "currency": "€",
      "services_by_org": [],
    }
  },
  getters: {
    getServices(state) {
      return state.services
    },
    getWidgetSettings(state) {
      return state.widget_settings
    },
    getLanguage(state) {
      return state.language
    },
  },
  mutations: {
    UPDATE_SERVICES(state, data) {
      state.services = data
    },
    UPDATE_WIDGET_SETTINGS(state, data) {
      state.widget_settings = data
    },
    UPDATE_SETTINGS(state, data) {
      state.widget_settings['id'] = data.id
      state.widget_settings['name'] = data.name
      state.widget_settings['confirm'] = data.currency
      state.widget_settings['currency'] = data.currency
      state.widget_settings['phone'] = data.phone
      state.widget_settings['email'] = data.email
      state.widget_settings['city'] = data.city
      state.widget_settings['address'] = data.address
      state.widget_settings['notification_enabled'] = data.notification_enabled
      state.widget_settings['parent_org'] = data.parent_org
      state.widget_settings['belong_to_parent_org'] = data.belong_to_parent_org
      state.widget_settings['workspace_by_org'] = data.workspace_by_org
      state.widget_settings['map_image_light'] = data.map_image_light
      state.widget_settings['payment_gateway'] = data.payment_gateway
    },
    UPDATE_LANGUAGE(state, data){
      state.language = data
    },
    updateServiceStatusAvailable(state, {index, value}) {
      state.services[index].is_available = value
    },
  },
  actions: {
    fetchSettingsAndServices(ctx, organization_id) {
      return new Promise((resolve, reject) => {
        axios.get(`/organizations/services-and-widget/${organization_id}`)
          .then(response => {
            ctx.commit('UPDATE_WIDGET_SETTINGS', response.data.widget)
            ctx.commit('UPDATE_SERVICES', response.data.services_by_org)
            ctx.commit('UPDATE_WORKSPACES', response.data.workspace_by_org)
            ctx.commit('UPDATE_LANGUAGE', response.data.language)
            ctx.commit('UPDATE_SETTINGS', response.data)
            if (ctx.rootState.error.error_service_status){
              ctx.commit('UPDATE_ERROR_TIMESLOT_STATUS', false)
              ctx.commit('UPDATE_ERROR_WORKSPACE_STATUS', false)
            }
            resolve()
          })
          .catch(error => {
            ctx.commit('UPDATE_WIDGET_SETTINGS', ctx.rootState.servicesAndSettings.error_settings)
            ctx.commit('UPDATE_ERROR_SERVICE_STATUS', true)
            ctx.commit('UPDATE_ERROR_WORKSPACE_STATUS', true)
            reject(error)
          })
      })
    },
  },
}
